import {
  allowedFileTypes,
} from "../constants/fileTypes";

/**
 * Compares the MIME type for the 'file' parameter to the 'allowedTypes'
 * parameter. Returns true if the 'file' is specified in the 'allowedTypes'.
 * @param file File
 * @returns boolean
 */
export const checkFileType = (
  file: File,
): boolean => {
      if (allowedFileTypes.some(fileType => fileType === file.type))
        return true;
      else return false;
};
